<script lang="ts">
  export let submit: (event: Event) => void;
  export let errors;
</script>

<form>
  <div style="display: flex; flex-direction: column; row-gap: 10px;">
    <slot/>

  {#if errors.message}
    <div style="color: red">
      {errors.message}
    </div>
  {/if}

    <button on:click={submit}>Submit</button>
  </div>
</form>
